// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_be-4";
export var collapsed = "_be-1";
export var headerBar = "_be-0";
export var leftHeaderContent = "_be-3";
export var subjectContainer = "_be-2";